import React from 'react';
import { useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

const NetworkError = () => {
  const location = useLocation();
  const { t } = useTranslation();

  const tryAgain = () => {
    window.onbeforeunload = null;
    window.location.replace(
      location.state?.path || process.env.PUBLIC_URL || '/'
    );
  };

  return (
    <div
      role="alert"
      aria-live="assertive"
      className="vf-network-error-card w-full max-w-md sm:max-w-lg rounded-3xl bg-white/10 backdrop-blur-xl border border-white/20 shadow-2xl flex flex-col items-center text-center gap-6 px-8 py-10 sm:px-10 text-white"
    >
      <img
        className="vf-network-error-art h-36 sm:h-44 w-auto object-contain pointer-events-none"
        src={`${process.env.PUBLIC_URL || ''}/images/disconnected.svg`}
        alt=""
      />
      <div className="flex flex-col gap-2">
        <h2 className="text-xl sm:text-2xl font-bold tracking-tight text-white">
          {t('errors.network_error.header')}
        </h2>
        <p className="text-xs sm:text-sm text-white/70 leading-relaxed max-w-sm">
          {t('errors.network_error.subHeader')}
        </p>
      </div>
      <button
        type="button"
        className="vf-network-error-retry mt-2 inline-flex items-center justify-center gap-2 min-w-44 font-bold rounded-xl py-3 px-6 bg-[#fbba36] text-[#001421] border border-[#fbba36] hover:bg-[#e7a200] focus:outline-none focus:ring-2 focus:ring-white/40"
        onClick={tryAgain}
        id="try_again"
      >
        {t('errors.network_error.button')}
      </button>
    </div>
  );
};

export default NetworkError;
